export default "__VITE_ASSET__CW9gD2fw__"